//import api from '../api';
import { newAPIPost } from '../api/index.js';
import config from '../config';

export default {
  state: {
    stores: [],
    storeSpecials: [],
    searchRequest: {},
    allStoreOptions: [],
  },
  mutations: {
    updateStoreSpecials(state, storeSpecials) {
      state.storeSpecials = storeSpecials;
    },
    updateAllStoreOptions(state, allStoreOptions) {
      state.allStoreOptions = allStoreOptions;
    },
    updateStoreSearchRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadStoreSpecials({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
      if (requestToSend.fromId && !requestToSend.toId) {
        requestToSend.toId = requestToSend.fromId;
      }
      if (requestToSend.fromState && !requestToSend.toState) {
        requestToSend.toState = requestToSend.fromState;
      }
      if (requestToSend.fromCity && !requestToSend.toCity) {
        requestToSend.toCity = requestToSend.fromCity;
      }
      //const result = await api.post('/api/w/stores', requestToSend);
      const result = await newAPIPost('/api/w/stores', requestToSend);

      const { stores, storeSpecials } = result;

      _(storeSpecials).each((ss) => {
        ss.storeDto = _(stores).find(it => it.id === ss.storeId);
      });
      commit('updateStoreSearchRequest', fallbackRequest);
      return commit('updateStoreSpecials', result.storeSpecials);
    },
    doActionOnStoreSpecial({ dispatch }, request) {
      //return api.post('/api/w/stores/special/action', request);
      return newAPIPost('/api/w/stores/special/action', request);
    },
    loadAllStoreOptions({ commit }) {
      $.getJSON('storeOptions.json').then(data => {
        commit('updateAllStoreOptions', data);
      })
    },
  },
  getters: {
    getStoreSpecials: (state) => _(state.storeSpecials).sortBy(it => it.storeId),
    getAllStoreOptions: (state) => state.allStoreOptions,
  },
};
